// npm
import { LoadingBar } from 'iview';
import axios from 'axios';
import Cookies from 'js-cookie';
// vuex
import store from '../store';
import { AUTO_LOGIN_ACTION } from '@/store/modules/user/constants';

LoadingBar.config({
  color: '#ff6c36'
});
// eslint-disable-next-line 
export const scrollBehavior = (to, from) => {
  return { x: 0, y: 0 };
};

export const beforeEach = async (to, from, next) => {
  LoadingBar.start();
  // 紀錄通路碼寫入 cookie
  const refid = to.query.r;
  if (refid){
     Cookies.set('refid', refid, { expires: 30 });
     axios.defaults.headers.refid=refid;
    }
    //console.log("logic-start-refid:"+refid);
    const re= to.query.partner;//20201005 Wen Add
    //const re2= to.query.codeid;
    if (re){
    Cookies.set('cid', re, { expires: 0.333 });
    axios.defaults.headers.cid = re;    
    }
const regist= to.query.x;  //20201105 Wen Add
    //const re2= to.query.codeid;
    if (regist)
  {    
    //console.log("logic-start-regist:"+regist);
    Cookies.set('x', regist, { expires: 0.333 });
    axios.defaults.headers.x = regist;    
  }


  // 判斷 cookie 內的 token 自動登入
  const token = Cookies.get('accessToken');
  const { isLogin } = store.state.user;
  const { requiresAuth, visitDirectly = true } = to.meta;
  const isVisitDirectly = from.path === '/' && from.name === null;
  const regStatus = Cookies.get('x');  //rol，未註冊 //20201105 Wen Add
  //console.log("logic-start-regist2:"+regStatus);
  if (to.name === 'channel') {
    const isDevMode = process.env.NODE_ENV === 'development';
    const { path } = to;
    Cookies.set('channel', path, { expire: 30 });
    const url = isDevMode ? 'https://localhost:5000' : 'https://ec.rockgp.com:5001';
    window.location.replace(`${url}${path}`);
  }

  // judge page whether visit directly
  if (!visitDirectly && isVisitDirectly) return next('/');
  // judge auto login
  if (token && !isLogin) {
    //console.log("11111-regStatus"+regStatus);
    if(regStatus!="undefined" ||regStatus!=""  ){  //第一次進入網頁、有token、沒登入、沒有cookie.x
      //console.log("22222");
    Cookies.remove('x');
    }
    const result = await store.dispatch(AUTO_LOGIN_ACTION);
    if (!result) return next('/');
    if (to.name === 'login' || to.path.includes('signup')) return next('/');
    return next();
  }else
  {  //有登入
    //console.log("33333"); //沒登入、沒token,有登入
    /*if(regStatus){  //沒登入
      console.log("44444");
    //return next('/signup'); //20201105 Wen Add undefined
    }else if(regStatus!="undefined")
    {
      console.log("55555");  //沒有cookie.x

    }*/
  }

  // user permission
  if (!requiresAuth) return next();
  if(regStatus && !token && !isLogin)return next('/signup'); //20201105 Wen Add
  if (!token) return next('/login');
 
  next();
};
// eslint-disable-next-line 
export const afterEach = (to, from, next) => {
  LoadingBar.finish();
};